import React from 'react';
import { MainLayout } from '@app/components';
import { TimesheetList } from '@app/features/Timesheet';
import { RHHeader } from '@app/features/RHHeader';

export const TimesheetScreen = () => {
  return (
    <MainLayout
      header={(
        <RHHeader />
      )}>

      <TimesheetList />
    </MainLayout>
  );
};
